<template>
  <div class="el-section">
    <dash-contracts></dash-contracts>
  </div>
</template>

<script>
import '@pagarme/contracts/web-comp'

export default {
  name: 'ContractsPage'
}
</script>
